import { z } from 'zod';

/**
 * SIL-2056 (SAPI P1-B): customer data-API key wire DTOs (migration 1122).
 * The plaintext token appears ONLY in the create response, once.
 */
export const API_KEY_SCOPES = ['data:read'] as const;
export const apiKeyScopeSchema = z.enum(API_KEY_SCOPES);
export const MAX_ACTIVE_API_KEYS_PER_ORG = 5;

export const apiKeyCreateBodySchema = z.object({
  name: z.string().trim().min(1).max(100),
});
export type ApiKeyCreateBody = z.infer<typeof apiKeyCreateBodySchema>;

export const apiKeySummarySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  /** 8 chars, display only. The full token is never retrievable. */
  prefix: z.string(),
  scopes: z.array(apiKeyScopeSchema),
  createdAt: z.string(),
  lastUsedAt: z.string().nullable(),
  expiresAt: z.string(),
  revokedAt: z.string().nullable(),
});
export type ApiKeySummary = z.infer<typeof apiKeySummarySchema>;

export const apiKeyListResponseSchema = z.object({ keys: z.array(apiKeySummarySchema) });
export type ApiKeyListResponse = z.infer<typeof apiKeyListResponseSchema>;

export const apiKeyCreatedResponseSchema = apiKeySummarySchema.extend({
  /** Plaintext token. Shown once; not stored. */
  token: z.string(),
});
export type ApiKeyCreatedResponse = z.infer<typeof apiKeyCreatedResponseSchema>;
